import React from 'react';
import { Select } from 'antd';
import { PLATFORM } from '../../utils/enum';

const PlatformSelect = ({ platform, setPlatform }) => {
    const options = [
        { label: '전체', value: PLATFORM.ALL },
        { label: 'Android', value: PLATFORM.AOS },
        { label: 'iOS', value: PLATFORM.IOS },
    ];

    return (
        <div style={{ marginRight: '10px' }}>
            <Select
                value={platform}
                style={{ width: 150 }}
                onChange={setPlatform}
            >
                {options.map(option => (
                    <Select.Option key={option.value} value={option.value}>
                        {option.label}
                    </Select.Option>
                ))}
            </Select>
        </div>
    );
}

export default PlatformSelect;
